import { spreadWheatType } from '@/modules/common/helpers/wheat-type.helper';
import { OfferDetails } from '@/modules/mixing/ts/buyers-prices.types';
import { IInitialFormState } from '@/modules/seller-account/hooks/use-add-offer.hook';

export const setOfferState = ({
  offerToEdit,
  setFormState,
  setDate,
  resetForm,
  formState,
}: IArgs) => {
  const offsetMinutes = new Date().getTimezoneOffset();
  if (offerToEdit) {
    // const adjustedDate: any = offerToEdit.expiration_offer
    //   ? new Date(
    //       new Date(String(offerToEdit.expiration_offer)).getTime() -
    //         offsetMinutes * 60 * 1000,
    //     )
    //   : null;

    const adjustedDate: any = offerToEdit.expiration_offer
      ? new Date(new Date(String(offerToEdit.expiration_offer)))
      : null;

    function addLeadingZero(num: number) {
      return num < 10 ? '0' + num : num;
    }

    const sortNType = spreadWheatType(Number(offerToEdit.wheat_type));
    setFormState({
      ...formState,
      id: offerToEdit.id,
      wheatClass: offerToEdit.wheat_class || 0,
      gluten: offerToEdit.gluten ? String(offerToEdit.gluten) : '',
      idk: offerToEdit.idk ? String(offerToEdit.idk) : '',
      clop: offerToEdit.clop ? String(offerToEdit.clop) : '',
      admixtureOtherCereals: offerToEdit.admixture_other_cereals
        ? String(offerToEdit.admixture_other_cereals)
        : '',
      nature: offerToEdit.nature ? String(offerToEdit.nature) : '',
      wheatDifferentType: offerToEdit.wheat_different_type
        ? String(offerToEdit.wheat_different_type)
        : '',
      protein: offerToEdit.protein ? String(offerToEdit.protein) : '',
      weed: offerToEdit.weed ? String(offerToEdit.weed) : '',
      humidity: offerToEdit.humidity ? String(offerToEdit.humidity) : '',
      expiryDate: adjustedDate
        ? `${adjustedDate.getFullYear()}-${addLeadingZero(
            adjustedDate.getMonth() + 1,
          )}-${addLeadingZero(adjustedDate.getDate())} ${addLeadingZero(
            adjustedDate.getHours(),
          )}:${addLeadingZero(adjustedDate.getMinutes())}:${addLeadingZero(
            adjustedDate.getSeconds(),
          )}`
        : '',
      cp: offerToEdit.cp ? String(offerToEdit.cp) : '',
      buyingPrice: offerToEdit.price ? Math.floor(+offerToEdit.price).toString() : '',
      year: offerToEdit.year ? String(offerToEdit.year) : '',
      sort: String(sortNType?.sort),
      type: String(sortNType?.type),
      wheatType: offerToEdit.wheat_type,
      pickup: offerToEdit.pickup,
    });
    // setFormState({ ...formState, gluten: 12 })

    var dateParts: any = String(offerToEdit.expiration_offer).split(/[.: ]/);
    var date = new Date(
      dateParts[0].split('-')[0],
      dateParts[0].split('-')[2],
      dateParts[0].split('-')[1],
      dateParts[1],
      dateParts[2],
      dateParts[3],
    );
    // const date = new Date(String(offerToEdit.expiration_offer));
    setDate({
      year: +dateParts[0].split('-')[0],
      month: +dateParts[0].split('-')[1],
      day: +dateParts[0].split('-')[2],
      hours: +dateParts[1],
      minutes: +dateParts[2],
    });
  } else {
    resetForm();
  }
};

interface IArgs {
  offerToEdit: OfferDetails;
  setFormState: any;
  formState: IInitialFormState;
  setDate: (val: {
    year: number;
    month: number;
    day: number;
    hours: number;
    minutes: number;
  }) => void;
  resetForm: () => void;
}
